/* Birmingham Wear - conseiller de taille. Données : métachamp boutique size_advisor.config */
(function () {
  function init(scope) {
  if (scope.dataset.ready) return;
  scope.dataset.ready = '1';

  var cfgEl = scope.querySelector('[data-bw-sa-config]');
  var i18nEl = scope.querySelector('[data-bw-sa-i18n]');
  var cfg, t;
  try { cfg = JSON.parse(cfgEl.textContent); t = JSON.parse('[' + i18nEl.textContent + ']'); } catch (e) { return; }
  var chart = cfg && cfg.charts && cfg.charts[scope.dataset.chart];
  if (!chart) return;

  // Placement : juste sous le choix de taille de la fiche produit.
  var target = document.querySelector('.product-single__box__block--variant_picker');
  if (target) { target.appendChild(scope); } else { scope.hidden = true; return; }

  var overlay = scope.querySelector('[data-bw-sa-overlay]');
  var form = scope.querySelector('[data-bw-sa-form]');
  var errorEl = scope.querySelector('[data-bw-sa-error]');
  var resultEl = scope.querySelector('[data-bw-sa-result]');
  var sizeEl = scope.querySelector('[data-bw-sa-size]');
  var applyBtn = scope.querySelector('[data-bw-sa-apply]');
  var labelEl = scope.querySelector('[data-bw-sa-label]');
  var contactEl = scope.querySelector('[data-bw-sa-contact]');
  var step1 = scope.querySelector('[data-bw-sa-step1]');
  var backBtn = scope.querySelector('[data-bw-sa-back]');
  var modal = scope.querySelector('.bw-sa__modal');
  var summaryEl = scope.querySelector('[data-bw-sa-summary]');
  var noteEl = scope.querySelector('[data-bw-sa-note]');
  var applyLabel = applyBtn.textContent;
  var tsys = (scope.querySelector('.bw-sa__tsys.is-active') || {}).dataset;
  tsys = tsys ? tsys.tsys : 'fr';
  var unit = 'metric';
  var recommended = null;
  var STORE = 'bw_size_advisor';

  function animate(el, cls) {
    if (!el) return;
    el.classList.remove('bw-sa__anim-right', 'bw-sa__anim-left');
    void el.offsetWidth;
    el.classList.add(cls);
    setTimeout(function () { el.classList.remove(cls); }, 350);
  }
  function showStep1(anim) { resultEl.hidden = true; if (backBtn) backBtn.hidden = true; if (step1) { step1.hidden = false; if (anim) animate(step1, 'bw-sa__anim-left'); } if (modal) modal.scrollTop = 0; }
  function open() {
    showStep1(false);
    overlay.classList.remove('is-opening'); void overlay.offsetWidth; overlay.classList.add('is-opening');
    overlay.hidden = false; document.documentElement.style.overflow = 'hidden'; document.documentElement.classList.add('bw-sa-open');
  }
  function close() { overlay.hidden = true; document.documentElement.style.overflow = ''; document.documentElement.classList.remove('bw-sa-open'); }

  function setUnit(u) {
    unit = u;
    scope.querySelectorAll('.bw-sa__unit').forEach(function (b) { b.classList.toggle('is-active', b.dataset.unit === u); });
    scope.querySelectorAll('[data-metric]').forEach(function (el) { el.hidden = u !== 'metric'; });
    scope.querySelectorAll('[data-imperial]').forEach(function (el) { el.hidden = u !== 'imperial'; });
  }

  function setTsys(sys) {
    tsys = sys;
    scope.querySelectorAll('.bw-sa__tsys').forEach(function (b) { b.classList.toggle('is-active', b.dataset.tsys === sys); });
    scope.querySelectorAll('[data-tsys-list]').forEach(function (el) { el.hidden = el.dataset.tsysList !== sys; });
  }

  function readTrouser() {
    var sel = form.querySelector('[data-tsys-list="' + tsys + '"]');
    return sel && sel.value ? tsys.toUpperCase() + ' ' + sel.value : '';
  }

  function nearestIndex(list, value) {
    var best = 0;
    for (var i = 1; i < list.length; i++) { if (Math.abs(list[i] - value) < Math.abs(list[best] - value)) best = i; }
    return best;
  }

  function lookup(cm, kg) {
    var r = nearestIndex(chart.heights, cm);
    var c = nearestIndex(chart.weights, kg);
    // Case vide = hors tableau : on oriente vers notre expert en taille.
    return chart.grid[r][c] || null;
  }

  function bump(size, steps) {
    var order = cfg.size_order || [];
    var i = order.indexOf(size);
    if (i < 0) return size;
    return order[Math.min(order.length - 1, i + steps)];
  }

  function readValues() {
    var cm, kg;
    if (unit === 'metric') {
      cm = parseFloat(form.cm.value); kg = parseFloat(form.kg.value);
    } else {
      cm = ((parseFloat(form.ft.value) || 0) * 12 + (parseFloat(form['in'].value) || 0)) * 2.54;
      kg = (parseFloat(form.lbs.value) || 0) * 0.4536;
    }
    return { cm: cm, kg: kg };
  }

  function sizeInputs() {
    var roots = [scope.closest('.product-single__box'), scope.closest('form'), document];
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i]) continue;
      var found = roots[i].querySelectorAll('.js-product-form-swatch input[type="radio"]');
      if (found.length) return Array.prototype.slice.call(found);
    }
    return [];
  }

  function matchingInput(size) {
    var names = (cfg.aliases && cfg.aliases[size]) || [size];
    var inputs = sizeInputs();
    for (var n = 0; n < names.length; n++) {
      for (var i = 0; i < inputs.length; i++) {
        if (String(inputs[i].value).trim().toUpperCase() === names[n].toUpperCase()) return inputs[i];
      }
    }
    return null;
  }

  function summary(v) {
    var parts = [];
    if (unit === 'metric') { parts.push(Math.round(v.cm) + ' cm', Math.round(v.kg) + ' kg'); }
    else { parts.push((form.ft.value || 0) + ' ft ' + (form['in'].value || 0) + ' in', (form.lbs.value || 0) + ' lbs'); }
    var tr = readTrouser();
    if (tr) parts.push((t[3] || '') + ' ' + tr.replace('UK ', 'W'));
    var fit = (form.querySelector('input[name="fit"]:checked') || {}).value;
    if (fit === '1' && t[4]) parts.push(t[4]);
    return parts.join(' · ');
  }

  // Mesures enregistrées (invisibles pour le client) sur l'article ajouté au panier, visibles dans la commande Shopify.
  function orderNote(v, size, outside) {
    var parts = [Math.round(v.cm) + ' cm', Math.round(v.kg) + ' kg'];
    if (unit === 'imperial') parts.push('(saisi : ' + (form.ft.value || 0) + ' ft ' + (form['in'].value || 0) + ' in, ' + (form.lbs.value || 0) + ' lbs)');
    var tr = readTrouser();
    if (tr) parts.push('Pantalon ' + tr);
    var fit = (form.querySelector('input[name="fit"]:checked') || {}).value;
    parts.push(fit === '1' ? 'Coupe ample' : 'Coupe standard');
    parts.push('Recommandé : ' + (outside ? 'hors tableau (expert)' : size));
    return parts.join(' · ');
  }
  function setOrderProp(text) {
    var pf = scope.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    if (!pf) return;
    var input = pf.querySelector('input[data-bw-sa-prop]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden'; input.name = 'properties[_Mesures]'; input.setAttribute('data-bw-sa-prop', '');
      pf.appendChild(input);
    }
    input.value = text;
  }

  function show(size, outside) {
    recommended = outside ? null : size;
    scope.classList.toggle('bw-sa--outside', !!outside);
    sizeEl.textContent = outside ? t[1] : size;
    if (labelEl) labelEl.hidden = !!outside;
    if (contactEl) contactEl.hidden = !outside;
    if (noteEl) noteEl.hidden = !!outside;
    applyBtn.hidden = outside || !matchingInput(size);
    applyBtn.textContent = applyLabel;
    if (step1) step1.hidden = true;
    resultEl.hidden = false;
    if (backBtn) backBtn.hidden = false;
    animate(resultEl, 'bw-sa__anim-right');
    if (modal) modal.scrollTop = 0;
  }

  scope.querySelector('[data-bw-sa-open]').addEventListener('click', open);
  scope.querySelector('[data-bw-sa-close]').addEventListener('click', close);
  if (backBtn) backBtn.addEventListener('click', function () { showStep1(true); });
  overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) close(); });
  scope.querySelectorAll('.bw-sa__unit').forEach(function (b) { b.addEventListener('click', function () { setUnit(b.dataset.unit); }); });
  scope.querySelectorAll('.bw-sa__tsys').forEach(function (b) { b.addEventListener('click', function () { setTsys(b.dataset.tsys); }); });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = readValues();
    if (!(v.cm >= 140 && v.cm <= 220 && v.kg >= 35 && v.kg <= 200)) {
      errorEl.textContent = t[0]; errorEl.hidden = false; resultEl.hidden = true; return;
    }
    errorEl.hidden = true;
    var minH = chart.heights[0] - 7, maxH = chart.heights[chart.heights.length - 1] + 15;
    var minW = chart.weights[0] - 7, maxW = chart.weights[chart.weights.length - 1] + 15;
    var size = lookup(v.cm, v.kg);
    var outside = !size || v.cm < minH || v.cm > maxH || v.kg < minW || v.kg > maxW;
    if (!outside) size = bump(size, parseInt((form.querySelector('input[name="fit"]:checked') || {}).value || '0', 10));
    // Taille recommandée absente de ce produit (ex. 5XL+ sur un costume) : on oriente aussi vers l'expert.
    if (!outside && sizeInputs().length && !matchingInput(size)) outside = true;
    show(size, outside);
    if (summaryEl) summaryEl.textContent = summary(v);
    setOrderProp(orderNote(v, size, outside));
    var trouser = readTrouser();
    try { localStorage.setItem(STORE, JSON.stringify({ unit: unit, cm: v.cm, kg: v.kg, trouser: trouser })); } catch (err) {}
    if (window.dataLayer) { try { window.dataLayer.push({ event: 'size_advisor', size: outside ? 'outside' : size, trouser: trouser || '', chart: scope.dataset.chart }); } catch (err) {} }
  });

  applyBtn.addEventListener('click', function () {
    var input = recommended && matchingInput(recommended);
    if (!input) return;
    var label = input.id ? document.querySelector('label[for="' + input.id + '"]') : null;
    if (label) { label.click(); } else { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
    applyBtn.textContent = t[2] + ' : ' + recommended;
    setTimeout(close, 700);
  });

  // Pré-remplissage avec les dernières valeurs saisies par le visiteur.
  try {
    var saved = JSON.parse(localStorage.getItem(STORE) || 'null');
    if (saved && saved.cm && saved.kg) {
      form.cm.value = Math.round(saved.cm); form.kg.value = Math.round(saved.kg);
      var totalIn = Math.round(saved.cm / 2.54);
      form.ft.value = Math.floor(totalIn / 12); form['in'].value = totalIn % 12;
      form.lbs.value = Math.round(saved.kg / 0.4536);
      if (saved.unit === 'imperial') setUnit('imperial');
    }
    if (saved && saved.trouser) {
      var parts = String(saved.trouser).split(' ');
      var sel = form.querySelector('[data-tsys-list="' + parts[0].toLowerCase() + '"]');
      if (sel) { setTsys(parts[0].toLowerCase()); sel.value = parts[1]; }
    }
  } catch (err) {}
  }
  function boot() { document.querySelectorAll('[data-bw-sa]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
